import { render } from "./WorkGroups.vue?vue&type=template&id=3914b6be"
import script from "./WorkGroups.vue?vue&type=script&lang=js"
export * from "./WorkGroups.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__